import "./public.scss";

import { Outlet } from "react-router-dom";

export function Public() {
  return (
    <div id="ShellPublic" className="public">
      <Outlet />
    </div>
  );
}

export default Public;
